// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oL-z","hovered":"pL-z","hoverImage":"qL-z","mainImage":"rL-z","imageNoBackground":"sL-z","fullSizeImage":"tL-z"};